import React from 'react';
import type { ColDef, EditableCallbackParams } from 'ag-grid-community';
import { LopCrudPage } from '../../components/LopCrudPage';
import {
  getISASecurityIdTypes,
  saveBatchISASecurityIdTypes,
} from '../../api/isaSecurityIdTypes';
import type { ISASecurityIdType } from '../../types/ISASecurityIdType';
import { t } from '../../i18n/t';

const isaSecurityIdTypesColumnDefs: ColDef<ISASecurityIdType>[] = [
  {
    field: 'securityIdTypeId',
    headerName: t('isaSecurityIdTypes.columns.securityIdTypeId'),
    width: 140,
    cellDataType: 'number',
    // Natural PK: editable on Add only; existing rows must keep their code.
    editable: (params: EditableCallbackParams<ISASecurityIdType>) =>
      (params.data as { __status?: string } | undefined)?.__status === 'added',
    sort: 'asc',
  },
  {
    field: 'securityIdTypeName',
    headerName: t('isaSecurityIdTypes.columns.securityIdTypeName'),
    flex: 1,
    editable: true,
  },
];

const newISASecurityIdTypeDefaults = (): Partial<ISASecurityIdType> => ({
  securityIdTypeId: 0,
  securityIdTypeName: '',
});

export function ISASecurityIdTypesPage() {
  return (
    <LopCrudPage<ISASecurityIdType>
      resourceCode="isaSecurityIdTypes"
      titleKey="isaSecurityIdTypes.pageTitle"
      idField="securityIdTypeId"
      getRows={getISASecurityIdTypes}
      saveBatch={(added, modified, deletedIds) =>
        saveBatchISASecurityIdTypes(added, modified, deletedIds as number[])
      }
      columnDefs={isaSecurityIdTypesColumnDefs}
      newRowDefaults={newISASecurityIdTypeDefaults}
    />
  );
}
